// extracted by mini-css-extract-plugin
export default {"image":"nodata_image__xw-hP","heading":"nodata_heading__CBsJj","paragraph":"nodata_paragraph__Tyn17"};